import React from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, Grid, DialogActions } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import DialogCloseButton from '../../../buttons/DialogCloseButton';
import UploadMediaButton from './common/UploadMediaButton';
import LogoStockImagesSearch from './sources/logo/stock-images/LogoStockImagesSearch';
import LogoPickerTabs from './tabs/logo/LogoPickerTabs';
import LogoStockImagesContainer from './sources/logo/stock-images/LogoStockImagesContainer';
import ImageCropperActions from './common/ImageCropperActions';
import ImageCropper from './common/ImageCropper';
import { mediaPickerActions } from './store';
import MediaPickersConstants from './MediaPickersConstants';
import { MEDIA_USAGE_TYPE } from '../CreatePageConstants';
import { trackEvent, AnalyticsConstants } from '../../../../utilities/analyticsUtilities';
import LogoAssets from './tabs/logo/LogoAssets';
import RemoveMediaButton from './common/RemoveMediaButton';

const styles = theme => ({
    imagesLibrarySection: {
        width: '100%',
        padding: `${theme.spacing(3, 0, 0, 0)} !important`,
        marginLeft: -theme.spacing(6),
        marginRight: -theme.spacing(6)
    },
    imagesDialogContent: {
        overflowY: 'hidden',
        padding: theme.spacing(1, 2)
    }
});

class LogoMediaPickerDialog extends React.Component {
    render() {
        const { classes, imageCropperVisible, imageCropperProcessing, logoMediaPickerOpen, logoPickerSelectedTab } = this.props;

        return (
            <Dialog
                open={logoMediaPickerOpen}
                onClose={this.onDialogClose}
                maxWidth='md'
                fullWidth={true}
                scroll='body'
                aria-labelledby='media-picker-dialog'
                TransitionProps={{
                    onEnter: this.onDialogEnter,
                    onExited: this.onDialogExit
                }}>
                <DialogTitle id='media-picker-dialog'>
                    Logo
                    <DialogCloseButton onClick={this.onDialogClose} />
                </DialogTitle>
                <DialogContent className={classes.imagesDialogContent}>
                    <Grid
                        container
                        direction='column'
                        justifyContent='center'
                        alignItems='center'
                        spacing={4}
                    >
                        <Grid hidden={imageCropperProcessing || imageCropperVisible}>
                            <UploadMediaButton 
                                title='Upload Logo'
                                recommendedSize={`${MediaPickersConstants.RECOMMENDED_IMAGE_SIZES.LOGO.WIDTH} x ${MediaPickersConstants.RECOMMENDED_IMAGE_SIZES.LOGO.HEIGHT}`}
                                mediaFormat={'png'}
                                mediaUsageType={MEDIA_USAGE_TYPE.LOGO}
                                uploadMimeTypes={MediaPickersConstants.LOGO_UPLOAD_MIME_TYPES}
                            />
                            <RemoveMediaButton
                                title='Remove Logo'
                                mediaUsageType={MEDIA_USAGE_TYPE.LOGO}
                            />
                        </Grid>
                        <Grid 
                            hidden={imageCropperProcessing || imageCropperVisible} 
                            className={classes.imagesLibrarySection}
                        >
                            <Grid
                                container
                                direction='column'
                                spacing={0}
                            >
                                <Grid className={classes.imageCollectionControlsWrapper}>
                                    <Grid
                                        container
                                        direction='row'
                                        justifyContent='space-between'
                                        alignItems='center'
                                    >
                                        <LogoPickerTabs />
                                        <Grid style={{flexGrow: 1}}></Grid>
                                        {logoPickerSelectedTab === MediaPickersConstants.MEDIA_PICKER_TABS.IMAGES && <LogoStockImagesSearch />}
                                    </Grid>
                                </Grid>

                                { this.renderTabContent(logoPickerSelectedTab) }
                            </Grid>
                        </Grid>
                        <Grid>
                            <ImageCropper cropperConfiguration={MediaPickersConstants.IMAGE_CROPPER_CONFIGURATION.LOGO} />
                        </Grid>     
                    </Grid>
                </DialogContent>
                {imageCropperVisible &&
                    <DialogActions>
                        <ImageCropperActions />
                    </DialogActions>
                }
            </Dialog>
        );
    }

    renderTabContent = (logoPickerSelectedTab) => {
        switch(logoPickerSelectedTab) {
            case MediaPickersConstants.MEDIA_PICKER_TABS.IMAGES:
                return <LogoStockImagesContainer />;
            case MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS:
                return <LogoAssets/>;
            default:
                return null;
        }
    }

    onDialogEnter = () => {
        const { loadDefaultLogoStockImages, loadUserLogoAssets, logoPickerSelectedTab } = this.props;

        // The dialog opens on My Assets now, so only the gallery actually on screen is fetched.
        if (logoPickerSelectedTab === MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS)
            loadUserLogoAssets(1, MediaPickersConstants.LOGO_ASSETS_PER_PAGE);
        else
            loadDefaultLogoStockImages();

        trackEvent('Opened Media Picker', {
            category: AnalyticsConstants.VIDEO_CATEGORY,
            type: 'logo'
        });
    }

    onDialogExit = () => {
        //clearImagesLibrary();
        //if (this.croppie) this.croppie.destroy();
    }

    onDialogClose = () => {
        const { setProperty, hideImageCropper } = this.props;
        setProperty('logoMediaPickerOpen', false);
        hideImageCropper();
    }
}

const mapStateToProps = (state) => {
    const { 
        imageCropperVisible,
        imageCropperProcessing,
        logoMediaPickerOpen,
        logoPickerSelectedTab
    } = state.mediaPicker;

    return { 
        imageCropperVisible,
        imageCropperProcessing,
        logoMediaPickerOpen,
        logoPickerSelectedTab
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const loadDefaultLogoStockImages = () => dispatch(mediaPickerActions.loadDefaultLogoStockImages());
    const loadUserLogoAssets = (pageNumber, itemsPerPage) => dispatch(mediaPickerActions.loadUserLogoAssets(pageNumber, itemsPerPage));
    const hideImageCropper = () => dispatch(mediaPickerActions.hideImageCropper());

    return { 
        setProperty,
        loadDefaultLogoStockImages,
        loadUserLogoAssets,
        hideImageCropper
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(LogoMediaPickerDialog, styles));